var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all",style:({backgroundImage: 'url(' + _vm.bg + ')'})},[_c('div',{staticClass:"all-txt"},[_c('div',{staticClass:"main-one"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentn)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }